import { render, staticRenderFns } from "./EditCurso.vue?vue&type=template&id=65323da0&scoped=true&"
import script from "./EditCurso.vue?vue&type=script&lang=js&"
export * from "./EditCurso.vue?vue&type=script&lang=js&"
import style0 from "./EditCurso.vue?vue&type=style&index=0&id=65323da0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65323da0",
  null
  
)

export default component.exports